import * as yup from "yup";

export const schema = yup.object().shape({
    partner_code: yup
        .string()
        .required()
        .min(3)
        .max(150),
    username: yup
        .string()
        .required()
        .min(3)
        .max(50),
    password: yup.string().when("id", {
        is: true,
        then: (schemaFinish) => schemaFinish.required("é obrigatório").min(8).max(50),
        otherwise: (schemaFinish) => schemaFinish.notRequired().min(8).max(50),
    }),
    name: yup
        .string()
        .required()
        .min(3)
        .max(150),
    email: yup
        .string()
        .required()
        .min(3)
        .max(255),
    access_profile_id: yup
        .number()
        .required(),
});